import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import polygon from '../../../../assets/images/icons/polygon/polygon.svg';
import close from '../../../../assets/images/icons/close.svg';

export const useStyles = makeStyles(({ fontSizes, palette, breakpoints }: Theme) => ({
  hint: {
    position: 'absolute',
    top: '23%',
    left: '46%',
    width: '14.75rem',
    padding: '1rem',
    border: 'none',
    borderRadius: '0.75rem',
    background: palette.primary.dark,
    color: palette.common.white,
    fontSize: fontSizes.xxs,
    lineHeight: 1.17,
    textAlign: 'left',
    zIndex: 3,
    [breakpoints.up('sm')]: {
      top: '14%',
      left: '46%',
    },
    [breakpoints.up('md')]: {
      width: '15rem',
      fontSize: fontSizes.xs,
    },
    [breakpoints.up('lg')]: {
      left: '48%',
      top: '10%',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-1rem',
      display: 'block',
      width: '1.5rem',
      height: '1.3rem',
      background: `no-repeat url(${polygon}) bottom left`,
      backgroundSize: 'contain',
      transform: 'rotate(180deg)',
    },

    '&::before': {
      content: '""',
      position: 'absolute',
      top: '0.75rem',
      right: '0.75rem',
      display: 'block',
      width: '1.25rem',
      height: '1.25rem',
      background: `no-repeat url(${close}) center`,
      backgroundSize: 'contain',
    },
  },
}));
